module.exports = __webpack_public_path__ + "static/media/audio.d932c606.mp3";